<!--
 * @Author: mazhigang
 * @Date: 2023-07-01 19:16:24
 * @LastEditors: mazhigang
 * @LastEditTime: 2024-01-31 13:18:15
-->
<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>推荐位管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageTabAdd">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <el-page-header @back="goBack" :content="title"> </el-page-header>
          </div>
          <el-form
            label-position="right"
            :model="ruleForm1"
            :rules="rules"
            ref="ruleForm"
            class="demo-ruleForm"
          >
            <el-form-item label="标题" prop="name">
              <el-input
                v-model="ruleForm1.name"
                placeholder="请输入标题"
              ></el-input>
            </el-form-item>
            <el-form-item label="副标题" prop="">
              <el-input
                v-model="ruleForm1.name1"
                placeholder="请输入副标题"
              ></el-input>
            </el-form-item>
            <el-form-item label="适配端" prop="terminal">
              <el-select
                v-model="ruleForm1.terminal"
                placeholder="请选择"
                style="margin-right: auto"
              >
                <el-option
                  :label="item.val"
                  :value="item.key"
                  v-for="(item, index) in configList"
                  :key="index"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="类型" prop="type">
              <el-cascader
                style="margin-right: auto"
                :props="cateProps"
                :show-all-levels="false"
                v-model="selectData"
                :options="cageryList"
                @change="handleChange"
              ></el-cascader>
            </el-form-item>
            <el-form-item
              label="是否强制观看"
              prop="sort"
              style="display: flex; align-items: center"
            >
              <el-radio-group v-model="ruleForm1.display">
                <el-radio label="1">是</el-radio>
                <el-radio label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="关闭方式" prop="terminal">
              <el-select
                v-model="ruleForm1.closeType"
                placeholder="请选择推荐位关闭方式"
                style="margin-right: auto"
              >
                <el-option label="不关闭" value="0"> </el-option>
                <el-option label="查看后关闭" value="1"> </el-option>
                <el-option label="手动关闭" value="2"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="倒计时" prop="">
              <div>
                <el-input
                  v-model="ruleForm1.num"
                  placeholder="请输入倒计时"
                ></el-input>
                <div style="color: red; font-size: 12px">
                  *关闭倒计时最小可设置3秒，并且在倒计时>0时不管关闭方式都会执行倒计时关闭
                </div>
              </div>
            </el-form-item>
            <el-form-item label="跳转地址" prop="">
              <el-input
                v-model="ruleForm1.url"
                placeholder="请输入跳转地址"
              ></el-input>
            </el-form-item>
            <el-form-item label="上传图片" prop="img">
              <el-upload
                style="margin-right: auto"
                list-type="picture-card"
                class="avatar-uploader"
                :action="uploadUrl"
                :headers="deader"
                :on-success="handleAvatarSuccess"
                :on-remove="handleRemove"
                :multiple="true"
                :file-list="ruleForm1.img"
                :limit="1"
              >
                <i class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
            <div style="padding: 0 0 20px 80px; font-size: 12px; color: red">
              尺寸：640×800
            </div>
            <el-form-item label="阅读数" prop="templateNo">
              <el-input
                v-model="ruleForm1.templateNo"
                placeholder="请输入阅读数"
              ></el-input>
              <el-button
                type="primary"
                class="btn"
                style="margin-left: 16px"
                @click="getNum()"
                >生成随机数</el-button
              >
            </el-form-item>
            <el-form-item label="短简介" prop="memo">
              <el-input
                type="textarea"
                v-model="ruleForm1.memo"
                placeholder="请输入短简介"
              ></el-input>
            </el-form-item>
            <el-form-item label="简介" prop="memo1">
              <el-input
                type="textarea"
                v-model="ruleForm1.memo1"
                placeholder="请输入简介"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                @click="resetForm1('ruleForm')"
                style="margin-left: 50px"
                >取消</el-button
              >
              <el-button
                type="primary"
                @click="submitForm('ruleForm')"
                style="margin-right: auto"
                >确定</el-button
              >
            </el-form-item>
          </el-form>
        </el-card>
      </div>
    </div>
  </div>
</template>
<script>
import system from "../../components/system_left.vue";
import axiosUrl from "../../api/axios.js";
export default {
  components: {
    system,
  },
  data() {
    return {
      leftList: this.Plugins.operateData(),
      title: "新增推荐位",
      ruleForm1: {
        name: "",
        terminal: "",
        name1: "",
        type: "",
        url: "",
        img: [],
        templateNo: "",
        memo: "",
        display: "0", // 默认强制观看
        memo1: "",
        closeType: "",
        num: "0",
      },
      rules: {
        type: [{ required: true, message: "必选项", trigger: "change" }],
        terminal: [{ required: true, message: "必选项", trigger: "change" }],
        name: [{ required: true, message: "必填项", trigger: "blur" }],
        closeType: [{ required: true, message: "必选项", trigger: "change" }],
      },
      editId: "",
      deader: {
        "x-ba-admin-token": localStorage.getItem("TOKEN"),
      },
      cageryList: [],
      selectData: [],
      configList: [],
      cateProps: {
        label: "name",
        value: "id",
        checkStrictly: true,
      },
      uploadUrl: "",
    };
  },
  created: function () {
    this.uploadUrl = axiosUrl.defaults.baseURL + "admapi/sys/file/upload";
    if (this.$route.query.id) {
      this.editId = this.$route.query.id;
      this.title = "编辑推荐位";
      this.getDetail();
    }
    this.getList1();
    this.getList();
  },
  methods: {
    getList() {
      let param = {
        page: 1,
        pageSize: 999999,
      };
      this.$axios
        .post(`/admapi/sys/conf/list`, param)
        .then(({ data }) => {
          let arr = data.items;
          let list = "";
          for (var i = 0; i < arr.length; i++) {
            if (arr[i].propName == "adUseType") {
              list = arr[i].propValue;
            }
          }
          this.configList = JSON.parse(list);
        })
        .catch()
        .finally();
    },
    handleChange(val) {
      this.ruleForm1.type = val[val.length - 1];
    },
    getNum() {
      let val = Math.floor(Math.random() * 10000);
      this.ruleForm1.templateNo = val;
    },
    getList1() {
      let param = {
        page: 1,
        pageSize: 1000,
      };
      this.$axios
        .post(`/admapi/categories/list`, param)
        .then(({ data }) => {
          this.cageryList = data;
        })
        .catch()
        .finally();
    },
    goBack() {
      this.$router.go(-1);
    },
    handleAvatarSuccess(res, file) {
      let obj = {};
      obj.url = res.data;
      this.ruleForm1.img.push(obj);
    },
    handleRemove(file, fileList) {
      this.ruleForm1.img = fileList || [];
    },
    resetForm1(formName) {
      this.$refs[formName].resetFields();
      this.$router.go(-1);
    },
    submitForm(formName) {
      if (this.ruleForm1.num != 0) {
        if (this.ruleForm1.num <= 2) {
          this.$message({
            message: "倒计时最小3秒",
            type: "warning",
          });
          return;
        }
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let list = this.ruleForm1.img;
          let arr = [];
          for (var i = 0; i < list.length; i++) {
            arr.push(list[i].url);
          }
          let param = {
            title: this.ruleForm1.name,
            coverImgUrl: arr[0],
            openUrl: this.ruleForm1.url,
            categoryId: this.ruleForm1.type,
            subTitle: this.ruleForm1.name1,
            shortIntroduce: this.ruleForm1.memo,
            introduce: this.ruleForm1.memo1,
            useType: this.ruleForm1.terminal,
            isForceView: this.ruleForm1.display,
            closeType: this.ruleForm1.closeType,
            closeTime: this.ruleForm1.num,
            viewCount: this.ruleForm1.templateNo,
          };
          if (this.editId == "") {
            this.$axios
              .post(`/admapi/category-items/add`, param)
              .then(({ data }) => {
                this.$message({
                  message: "添加成功",
                  type: "success",
                });
                this.goBack();
              })
              .catch()
              .finally((this.dialogFormVisible = false));
          } else {
            param.id = this.editId;
            this.$axios
              .post(`/admapi/category-items/update/${this.editId}`, param)
              .then(({ data }) => {
                this.$message({
                  message: "编辑成功",
                  type: "success",
                });
                this.goBack();
              })
              .catch()
              .finally(() => {
                this.dialogFormVisible = false;
                this.editId = "";
                this.ruleForm1.name = "";
                this.ruleForm1.name1 = "";
                this.ruleForm1.terminal = "";
                this.ruleForm1.type = "";
                this.selectData = [];
                this.ruleForm1.url = "";
                this.ruleForm1.memo = "";
                this.ruleForm1.memo1 = "";
                this.ruleForm1.closeType = "";
                this.ruleForm1.num = "0";
                this.ruleForm1.templateNo = "";
                this.ruleForm1.img = [];
              });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getDetail() {
      this.$axios
        .post(`/admapi/category-items/get/${this.editId}`)
        .then(({ data }) => {
          this.detail = data;
          this.ruleForm1.name = data.title;
          this.ruleForm1.name1 = data.subTitle;
          this.ruleForm1.type = data.categoryId;
          this.selectData = data.categoryId;
          this.ruleForm1.url = data.openUrl;
          this.ruleForm1.memo = data.shortIntroduce;
          this.ruleForm1.terminal = data.useType;
          this.ruleForm1.memo1 = data.introduce;
          this.ruleForm1.closeType = data.closeType.toString();
          this.ruleForm1.num = data.closeTime;
          this.ruleForm1.display = data.isForceView.toString();
          this.ruleForm1.templateNo = data.viewCount;
          let arr = data.coverImgUrl.split(",");
          for (var i = 0; i < arr.length; i++) {
            this.ruleForm1.img.push({
              url: arr[i],
            });
          }
        })
        .catch()
        .finally();
    },
  },
};
</script>
<style scoped>
.demo-ruleForm {
  width: 650px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  margin: 0 auto;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
